import { Link } from '@tanstack/react-router'
import { ChevronRight, Link2, UtensilsCrossed } from 'lucide-react'
import { toast } from 'sonner'
import { useCurrentBusiness } from '~/entities/business/model/use-business'
import { useListing } from '~/entities/listing/model/use-listings'
import * as m from '~/paraglide/messages'
import { copyToClipboard, getListingShareUrl } from '~/shared/lib/share'

const ROW =
  'flex w-full items-center gap-3 rounded-md px-3 py-2.5 text-left font-medium text-sm outline-none transition-colors hover:bg-accent focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50'

export function ListingQuickLinks({ listingId }: { listingId: string }) {
  const { data: business } = useCurrentBusiness()
  const { data: listing } = useListing(business?.id ?? '', listingId)

  if (!listing) return null

  const isDraft = listing.isDraft || listing.status === 'Draft'

  const handleCopy = async () => {
    const ok = await copyToClipboard(getListingShareUrl(listingId))
    if (ok) {
      toast.success(m.linkCopied(), { description: m.linkCopiedToClipboard() })
    } else {
      toast.error(m.failedToCopyLink())
    }
  }

  return (
    <div className="-mx-3 flex flex-col gap-1">
      <Link to="/dashboard/menu" search={{ listingId }} className={ROW}>
        <UtensilsCrossed className="size-4 shrink-0 text-muted-foreground" />
        <span className="min-w-0 flex-1 truncate">{m.menuPageTitle()}</span>
        <ChevronRight className="size-4 shrink-0 text-muted-foreground" />
      </Link>
      <button type="button" className={ROW} onClick={handleCopy} disabled={isDraft}>
        <Link2 className="size-4 shrink-0 text-muted-foreground" />
        <span className="min-w-0 flex-1 truncate">{m.placeDetailCopyLink()}</span>
      </button>
      {isDraft && (
        <p className="px-3 pb-2 text-muted-foreground text-xs">{m.publishBeforeSharing()}</p>
      )}
    </div>
  )
}
